'use client';
/* eslint @typescript-eslint/no-var-requires: "off" */
const { Swiper } = require('swiper/react');
import React, { useEffect, useState } from 'react';

import bannerStyles from './bannerStyles.module.css';

import { useScreenSize } from '@/hooks/useScreenSize';

import { Carousel, CarouselRenderItemInfo } from '@/components/atoms/carousel';
import ImageSB from '@/components/atoms/image/ImageSB';

import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/utils/browserStorage';

import { BannerContent } from './BannerContent';
import {
  BANNER_TOP_CLOSED,
  DEFAULT_DESKTOP_OFFSET,
  HEADER_HEIGHT_DESKTOP,
  swiperConfig,
} from './constants';
import { BannerContentProps, TopBannerProps } from './types';

import ArrowLeft from '~/svg/IconChevronLeft.svg';
import ArrowRight from '~/svg/IconChevronRight.svg';
import IconClose from '~/svg/IconCross.svg';

// TODO fix data trackers
export const TopBanner = ({ bannerContent }: TopBannerProps) => {
  const [swiperRef, setSwiperRef] = useState<typeof Swiper | null>(null);
  const [isTopBannerOpen, setIsTopBannerOpen] = useState(true);
  const [offset, setOffset] = useState<number>(DEFAULT_DESKTOP_OFFSET);
  const [isClient, setIsClient] = useState(false);
  const { isTablet, isMobile } = useScreenSize();

  const isMultipleItems = bannerContent?.length > 1;

  const onScroll = () => {
    if (window.scrollY < HEADER_HEIGHT_DESKTOP) {
      setOffset(DEFAULT_DESKTOP_OFFSET);
    } else {
      setOffset(isTablet || isMobile ? 36 : 52);
    }
  };

  const handleClose = () => {
    setIsTopBannerOpen(false);
    setSessionStorageItem(BANNER_TOP_CLOSED, JSON.stringify(true));
  };

  const handleRightArrowClick = () => {
    swiperRef!.slideNext();
  };

  const handleLeftArrowClick = () => {
    swiperRef!.slidePrev();
  };

  useEffect(() => {
    setIsClient(true);
    getSessionStorageItem(BANNER_TOP_CLOSED)
      ? setIsTopBannerOpen(false)
      : setIsTopBannerOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [isMobile, isTablet]);

  const renderCarouselItem = ({
    item,
  }: CarouselRenderItemInfo<BannerContentProps>) => (
    <BannerContent
      {...item}
      renderImage={(props) => <ImageSB inner={props} block={item.bannerIcon} />}
    />
  );
  return (
    isTopBannerOpen &&
    isClient && (
      <div
        data-tracker-section='top-banner'
        style={{ transform: `translateY(${offset}px)` }}
        className={`${bannerStyles.banner} fixed top-3 z-20 mx-auto flex min-h-[52px] w-full justify-center bg-gradient-to-r from-[#01F0D3] to-[#9A4BFF] p-5 shadow-sm will-change-transform md:px-10 md:py-0`}
      >
        <div className='flex min-h-[52px] w-[85%] max-w-[1440px] items-center justify-center xl:w-full xl:justify-end'>
          {isMultipleItems ? (
            <div
              onClick={handleLeftArrowClick}
              className='mr-2 cursor-pointer md:mr-6'
              data-tracker='top-banner-left-arrow'
            >
              <ArrowLeft />
            </div>
          ) : (
            <div className='mr-2 h-4 w-4 md:mr-6'></div>
          )}
          <Carousel
            renderItem={renderCarouselItem}
            items={bannerContent}
            config={{
              ...swiperConfig,
              loop: isMultipleItems ? true : false,
              onSwiper: (swiper: typeof Swiper) => setSwiperRef(swiper),
            }}
            sideGradient={false}
          />
          {isMultipleItems ? (
            <div
              onClick={handleRightArrowClick}
              className='ml-2 cursor-pointer md:ml-6'
              data-tracker='top-banner-right-arrow'
            >
              <ArrowRight />
            </div>
          ) : (
            <div className='ml-2 h-4  w-4 md:ml-6'></div>
          )}
          <div
            className='absolute right-3 top-5 cursor-pointer sm:right-5 md:static md:ml-6 xl:ml-[110px]'
            onClick={handleClose}
            data-tracker='close-promo-banner'
          >
            <div className='h-6 w-6'>
              <IconClose />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
